import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination, Hospital } from '@/types/_'
import Apis from '@/Apis/_'

export interface Pais {
  id: string,
  nome: string,
  isoCode: string,
  ddi: string,
  // mask?: string,
  hisId?: string,
}

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  pais: boolean,
}

@Module({ namespaced: true, name: 'SuportePaisesStore' })
export default class SuportePaisesStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''
  public searchPais: string = ''
  public modal: SuporteModal = {
    pais: false,
  }

  @Mutation
  setSearchPais(val: string) {
    this.searchPais = val
  }

  @Mutation
  clearSearchPais() {
    this.searchPais = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** Países */
  private paisesDefault: Pais[] = []
  public paises: Pais[] = [...this.paisesDefault]
  public paisesJson: any = {}

  private paisDefault: Pais = {
    id: '',
    nome: '',
    isoCode: '',
    ddi: '',
    // mask: '',
    hisId: '',
  }

  public pais: Pais = { ...this.paisDefault }

  @Mutation
  setPaises(paises: Pais[]) {
    this.paises = paises
  }

  @Mutation
  clearPaises() {
    this.paises = [...this.paisesDefault]
  }

  @Mutation
  setPais(pais: Pais) {
    this.pais = pais
  }

  @Mutation
  clearPais() {
    this.pais = { ...this.paisDefault }
  }

  @Mutation
  setPaisesJson(json: any) {
    this.paisesJson = json
  }

  @Mutation
  clearPaisesJson() {
    this.paisesJson = {}
  }

  @Action
  async getPaisAll() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getPaisAll(this.hospitalId)
      if (request.success) this.context.commit('setPaises', request.data as Pais[] || [])
      return request
    } catch (error) {
      this.context.commit('setPaises', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertPaisHospital() {
    try {
      const request = await Apis.Agendamento.SuporteApi.upsertPaisHospital({ hospitalId: this.hospitalId, ...this.pais })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async importPaisJson() {
    try {
      const request = await Apis.Agendamento.SuporteApi.importPaisJson(this.hospitalId, this.paisesJson)
      if (request.success) this.context.dispatch('getPaisAll')
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
